"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Select.module.css"));
var Select = (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        return _super.call(this, props) || this;
    }
    Select.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, onChange = _a.onChange, options = _a.options, _b = _a.errors, errors = _b === void 0 ? {} : _b;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", null,
            React.createElement("select", { id: id, className: css, value: value, onChange: function (event) {
                    event.preventDefault();
                    onChange(id, event.target.value);
                } },
                React.createElement("option", { value: "" }, "-- select --"),
                options &&
                    options.map(function (item) {
                        return (React.createElement("option", { key: item.value, value: item.value }, item.name));
                    })),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return Select;
}(React.Component));
exports.Select = Select;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VsZWN0LmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9TZWxlY3QvU2VsZWN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBRTlCLDBEQUE2QztBQVc3QztJQUE0QiwwQkFBZ0M7SUFDeEQsZ0JBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBQ00sdUJBQU0sR0FBYjtRQUNVLElBQUEsZUFBNEQsRUFBM0Qsd0JBQVMsRUFBRSxVQUFFLEVBQUUsc0JBQVEsRUFBRSxvQkFBTyxFQUFFLGNBQVcsRUFBWCxnQ0FBeUIsQ0FBQTtRQUNsRSxJQUFJLEtBQUssR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFBO1FBQy9CLElBQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUV4QixJQUFJLEdBQUcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFBO1FBQ3JCLElBQUksS0FBSyxFQUFFO1lBQ1AsR0FBRyxHQUFNLEdBQUcsU0FBSSxNQUFNLENBQUMsU0FBVyxDQUFBO1NBQ3JDO1FBRUQsT0FBTyxDQUNIO1lBQ0ksZ0NBQ0ksRUFBRSxFQUFFLEVBQUUsRUFDTixTQUFTLEVBQUUsR0FBRyxFQUNkLEtBQUssRUFBRSxLQUFLLEVBQ1osUUFBUSxFQUFFLFVBQUMsS0FBSztvQkFDWixLQUFLLENBQUMsY0FBYyxFQUFFLENBQUE7b0JBQ3RCLFFBQVEsQ0FBQyxFQUFFLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQTtnQkFDcEMsQ0FBQztnQkFDRCxnQ0FBUSxLQUFLLEVBQUMsRUFBRSxtQkFBc0I7Z0JBQ3JDLE9BQU87b0JBQ0osT0FBTyxDQUFDLEdBQUcsQ0FBQyxVQUFDLElBQW9CO3dCQUM3QixPQUFPLENBQ0gsZ0NBQVEsR0FBRyxFQUFFLElBQUksQ0FBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLLElBQ3JDLElBQUksQ0FBQyxJQUFJLENBQ0wsQ0FDWixDQUFBO29CQUNMLENBQUMsQ0FBQyxDQUNEO1lBQ1IsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ2hELENBQ1QsQ0FBQTtJQUNMLENBQUM7SUFDTCxhQUFDO0FBQUQsQ0FBQyxBQXRDRCxDQUE0QixLQUFLLENBQUMsU0FBUyxHQXNDMUM7QUF0Q1ksd0JBQU0ifQ==